import * as Types from '../types';
import { Environment } from '../../../config';
import request from '../../../utils/request';
import * as DateUtils from 'utils/dates';

interface IDataItems {
  message_incoming_id: number;
  lxr_ccn_id: string;
  application_type: string;
  file_name: string;
  message_text: string;
  message_file: string;
  message_type: string;
  originating_country: string;
  destination_country: string;
  message_id: string;
  correlation_id: string;
  ccncsi_correlation_id: string;
  sent_flag: number;
  read_flag: number;
  message_ref_id: number;
  transmision_date: Date;
  created_by: string;
  created_at: Date;
  modified_by: string;
  modified_at: Date;
}

interface IPaging {
  page: string;
  pageSize: string;
  total: number;
}

interface IMessageIncomingListOutput {
  items: IDataItems[];
  paging: IPaging;
}

interface IMessageIncomingListInput {
  sortField: string;
  page: number;
  pageSize: number;
  order: 'asc' | 'desc';
  messageId?: string;
  originatingCountry?: string;
  messageType?: string;
  status?: string | null;
  date_from?: Date | null;
  date_to?: Date | null;
}

export const fetchMessageIncoming = async (
  payload: IMessageIncomingListInput
): Promise<Types.ResponseOutput> => {
  let searchQuery = '';
  if (payload.messageId) searchQuery += `&messageId=${payload.messageId}`;
  if (payload.originatingCountry)
    searchQuery += `&originatingCountry=${payload.originatingCountry}`;
  if (payload.messageType) searchQuery += `&messageType=${payload.messageType}`;
  if (payload.status) searchQuery += `&status=${payload.status}`;
  if (payload.date_from)
    searchQuery += `&date_from=${DateUtils.DateInQueryFormat(
      payload.date_from
    )}`;
  if (payload.date_to)
    searchQuery += `&date_to=${DateUtils.DateInQueryFormat(payload.date_to)}`;

  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/message-incoming/list?page=${payload.page}&pageSize=${payload.pageSize}&sortField=${payload.sortField}&order=${payload.order}${searchQuery}`
  );

  let _data: IMessageIncomingListOutput = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

export const fetchMessageIncomingXml = async (payload: {
  messageId: string;
}): Promise<Types.ResponseOutput> => {
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/message-incoming/getXml/${payload.messageId}`
  );

  let _data: string = data.data.message_text;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};
